<template>
	<div class="relative">
		<div class="fixed white" style="width: 100%;" id="tool-bar">
			<v-row style="width: 100%" align="center" justify="start" class="ma-0">
				<v-col cols="auto" sm="6" xs="6" md="12" lg="auto">
					<slot name="breadcrumbs"></slot>
				</v-col>
				<v-spacer/>
				<v-col cols="auto" v-if="showExportBtns">
					<!-- export -->
					<v-menu offset-y>
						<template v-slot:activator="{ on }">
							<v-btn dark color="printingColor" class="px-2" v-on="on">
								<span class="d-flex align-center">
									<v-icon color="white">mdi-export-variant</v-icon>
									<span style="font-size: 14px">
										{{$t('WarehouseInventoryPage.export')}}
									</span>
								</span>
							</v-btn>
						</template>

						<bee-list>
							<!-- excel -->
							<bee-list-item
								context="inventory"
								:item="exportItems[0]"
								dense
								@click="exportAs('excel')"
							></bee-list-item>

							<!-- pdf -->
							<bee-list-item
								context="inventory"
								:item="exportItems[1]"
								dense
								@click="exportAs('pdf')"
							></bee-list-item>
						</bee-list>
					</v-menu>
				</v-col>
			</v-row>
			<v-layout wrap class="d-flex flex-row my-border rounded-lg mx-3 mb-3 align-center">
				<!-- FIXME making warehousesForKeeper works not all warehouses -->
				<v-col cols="auto" lg="2" md="auto" sm="6" xs="12" class="pe-lg-0">
					<bee-autocomplete
						v-model="warehouse_id"
						:label="$t('WarehouseInventoryPage.warehouse')"
						:items="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? warehousesForKeeper : warehouses"
						:item-text="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_name' : 'name'"
						:item-value="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_id' : 'id'"
						@keydown-enter-prevent="search()"
						:hide-details="true"
						:loading="warehousesLoading"
						context="inventory"
						:action-name="actions.GET"
						@change="materials_id=[]"
					></bee-autocomplete>
				</v-col>

				<v-col cols="auto" lg="3" md="auto" class="pe-lg-0">
					<!-- fixed for multiple warehouses -->
					<!-- FIXME making tableInputs.warehouse_id works -->
					<!-- :items="
						userTypePermission === userType.warehouseKeeper &&
						multipleWarehouses
							? materials.filter(c => c.warehouse_id === tableInputs.warehouse_id && c.type === 2)
							: warehouse_id
								? materials.filter(c => c.warehouse_id === warehouse_id)
								: materials
					" -->
					<bee-material-autocomplete
						:label="$t('WarehouseInventoryPage.search-by-material-name-or-num')"
						:items="
							warehouse_id
								? materials.filter(c => c.warehouse_id === warehouse_id)
								: materials
						"
						v-model="materials_id"
						ref="BeeAutocomplete"
						@keydown-enter-prevent="search()"
						:with-balance="true"
						:hide-details="true"
						:loading="materialsLoading"
						clearable
						context="inventory"
						:action-name="actions.GET"
						:item-color="item => item.type === type.main ? 'orangeLighten5' : null"
						:multiple="true"
					></bee-material-autocomplete>
				</v-col>

				<!-- <v-col cols="auto">
					<v-autocomplete 
						v-model="deliveryStatus"
						:items="materialDeliveryStatus"
						item-text="name"
						item-value="id"
						outlined
						hide-details
						dense
						:label="$t('WarehouseInventoryPage.material-delivery-status')"
					/>
				</v-col> -->
				<v-col v-if="materialQuantityAlert" cols="auto" lg="2" md="auto" sm="6" xs="12" class="pe-lg-0">
					<v-autocomplete
						v-model="quantity_status"
						:label="$t('WarehouseInventoryPage.quantity-status')"
						:items="[{name: $t('all'), id: null} , ...quantityStatusValues]"
						outlined
						dense
						item-text="name"
						item-value="id"
						:hide-details="true"
					></v-autocomplete>
				</v-col>
				<v-col cols="auto" lg="auto" md="auto" class="d-flex flex-column py-0">
					<v-checkbox
						v-model="with_primary_materials"
						:label="$t('WarehouseInventoryPage.show-main-materials')"
						class="small-font-size mt-0"
						dense
						hide-details
					></v-checkbox>
					<v-checkbox
						v-model="where_materials_have_balances"
						dense
						:label="$t('WarehouseInventoryPage.only-materials-which-have-balances')"
						class="small-font-size mt-0 pb-1"
						hide-details
					></v-checkbox>
				</v-col>
				<!-- <v-col cols="auto" lg="auto" md="auto" sm="6" xs="12" class="d-flex align-center pe-lg-0">

				</v-col> -->
				<v-spacer></v-spacer>
				<v-col cols="auto" lg="auto" md="auto" sm="6" xs="12" class="d-flex align-center justify-end">
					<bee-btn
						@click="search()"
						:content="$t('WarehouseInventoryPage.refresh')"
						color="blueGray"
						outer-class="me-3"
						:disabled="loading"
						:loading="searchingLoading"
						context="inventory"
						:action-name="actions.GET"
					></bee-btn>
					<bee-btn
						@click="reset()"
						:content="$t('WarehouseInventoryPage.cancel')"
						color="deletingColor"
						:disabled="searchingLoading || loading"
						context="inventory"
						:action-name="actions.GET"
					></bee-btn>
				</v-col>
			</v-layout>
		</div>
		<div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
			<v-card flat>
				<v-card-text class="py-0 px-3">

					<bee-handy-table
						:headers="headers"
						:items="inventory_rows"
						:fixed-header="true"
						:height="$vuetify.breakpoint.height - 315"
						pagination-on-scroll
						shown-rows-text=""
						:zebra="zebra"
						:loading="searchingLoading"
						:context-menu-items="contextMenuItems"
						:item-class="item => item.is_parent ? 'orangeLighten5' : null"
						@contextmenu:row="(e, data) => contextMenuItem = data.item"
						@context-menu-edit="editInventoryPrice($event.item); event = 'edit'"
						@context-menu-statement="statement($event.item); event = 'statement'"
						@dblclick:row="(e, { item }) => {
							statement(item); event = 'statement'
						}"
					>
					
					<template v-slot:item.new_price="{ item }">
						<v-tooltip
							bottom
						>
							<template v-slot:activator="{on, attrs}">
								<span v-on="on" v-bind="attrs" 
								:style="item.new_price.inventory_price === inventoryPriceType.inventory? 'color:green': 'color: black' "
								>
									{{ item.new_price.amount }}
								</span>
							</template>
							<span>
								{{ 
									item.new_price.inventory_price === inventoryPriceType.inventory ?
									$t('WarehouseInventoryPage.from-inventory')
									: $t('WarehouseInventoryPage.from-invoice')
								}}
							</span>
						</v-tooltip>
					</template>
					<template v-slot:item.options="{ item }">
						<div class="text-center">
							<v-menu offset-y>
								<template v-slot:activator="{ on, attr }">
									<v-btn
										small
										icon
										v-bind="attr"
										v-on="on"
										width="32"
									>
										<v-icon>
											mdi-dots-vertical
										</v-icon>
									</v-btn>
								</template>
								<v-list dense>
									<v-list-item @click="editInventoryPrice(item); event = 'edit'">
										<v-list-item-content class="pa-0">
											{{ $t('WarehouseInventoryPage.context-menu.edit-inventory-price') }}
										</v-list-item-content>
									</v-list-item>
									<v-list-item @click="statement(item); event = 'statement'">
										<v-list-item-content class="pa-0">
											{{ $t('WarehouseInventoryPage.context-menu.material-statement') }}
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>
						</div>
					</template>
					<template v-slot:item.quantity="{item}">
						<v-tooltip
							bottom
							v-if="item.quantity_status && materialQuantityAlert"
						>
							<template v-slot:activator="{on, attrs}">
								<span 
									v-on="on" 
									v-bind="attrs" 
									:class="
									item.quantity_status === quantityStatus.belowMinimum 
										? 'danger-color--text'
										:  item.quantity_status === quantityStatus.aboveMaximum
											?'preview-color--text'
											:''
									"
								>
								{{item.quantity?.quantity}}
								</span>
							</template>
							<span>
								{{ 
									item.quantity_status === quantityStatus.belowMinimum 
									? $t('WarehouseInventoryPage.below-minimum')
									: item.quantity_status === quantityStatus.aboveMaximum 
										? $t('WarehouseInventoryPage.above-maximum')
										:null
								}}
							</span>
						</v-tooltip>
						<span v-else>
							{{ item.quantity?.quantity }}
						</span>
					</template>
					</bee-handy-table>

				</v-card-text>
			</v-card>
			<v-bottom-navigation app id="footer" class="px-3" horizontal background-color="greyLighten3">
				<v-row align="center" justify="center">

					<!-- العدد الكلي -->
					<v-col cols="auto">
						<bee-outlined-header-info
						    :head="$t('WarehouseInventoryPage.total-count')"
						    border-color="transparent"
						    class="pa-lg-0"
						>
							<template v-slot:content="{}">
								<bee-material-amount-label
									:value="total_count"
									empty-state="_"
								></bee-material-amount-label>
							</template>
						</bee-outlined-header-info>
					</v-col>
					<v-spacer></v-spacer>

					<!-- مجموع الكميات المدخلة -->
					<v-col cols="auto">
						<bee-outlined-header-info
						    :head="$t('WarehouseInventoryPage.sum-input-quantity')"
						    border-color="transparent"
						    class="pa-lg-0"
						>
							<template v-slot:content="{}">
								<bee-material-amount-label
									:value="{ quantity: summary.sum_input_quantity }"
									empty-state="_"
								></bee-material-amount-label>
							</template>
						</bee-outlined-header-info>
					</v-col>

					<!-- مجموع الكميات المخرجة -->
					<v-col cols="auto">
						<bee-outlined-header-info
						    :head="$t('WarehouseInventoryPage.sum-output-quantity')"
						    border-color="transparent"
						    class="pa-lg-0"
						>
							<template v-slot:content="{}">
								<bee-material-amount-label
									:value="{ quantity: summary.sum_output_quantity }"
									empty-state="_"
								></bee-material-amount-label>
							</template>
						</bee-outlined-header-info>
					</v-col>

					<!-- الكمية الكلية -->
					<v-col cols="auto" class="ml-16">
						<bee-outlined-header-info
						    :head="$t('WarehouseInventoryPage.total-quantity')"
						    border-color="transparent"
						    class="pa-lg-0"
						>
							<template v-slot:content="{}">
								<bee-material-amount-label
									:value="sum_quantity"
									empty-state="_"
								></bee-material-amount-label>
							</template>
						</bee-outlined-header-info>
					</v-col>
					<v-col cols="auto" class="mr-4"></v-col>

					<!-- جرد المستودع -->
					<v-col cols="auto" class="mb-1">
						<bee-outlined-header-info
						    :head="$t('WarehouseInventoryPage.warehouse-inventory')"
						    border-color="transparent"
						    class="pa-lg-0"
						>
							<template v-slot:content="{}">
								<bee-money-label :number="sum_total_amount.amount" :type="sum_total_amount.type" :withColor="true" empty-state="_"></bee-money-label>
							</template>
						</bee-outlined-header-info>
					</v-col>
				</v-row>
			</v-bottom-navigation>
			<v-form v-model="valid">
				<v-dialog
					persistent
					v-model="dialogEditInventoryPrice"
					max-width="400px"
					transition="dialog-top-transition"
				>
					<v-card>
						<v-card-title>{{ formTitle }}</v-card-title>

						<v-card-text class="pb-0">
							<v-row justify="center">
								<v-col cols="12" class="mx-5">
									<bee-numeric-field
										context="material"
										:action-name="actions.EDIT"
										v-model="inventoryPrice"
										:label="$t('WarehouseInventoryPage.inventory-price')"
										:rules="[rules.money]"
									></bee-numeric-field>
								</v-col>
							</v-row>
						</v-card-text>

						<v-card-actions class="px-5">
							<v-btn color="greenDarken1" text @click="confirmEditInventoryPrice()" :disabled="!valid">
								{{$t('WarehouseInventoryPage.save')}}
							</v-btn>
							<v-btn color="redDarken1" text @click="close()">
								{{$t('WarehouseInventoryPage.cancel')}}
							</v-btn>
							<v-spacer></v-spacer>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-form>
			<bee-confirm-dialog
				@close="alertEditingPrimaryMaterial = false"
				confirm-button-color="red"
				v-model="alertEditingPrimaryMaterial"
				:title="$t('WarehouseInventoryPage.warning')"
				:message="$t('WarehouseInventoryPage.it-is-not-possible-to-set-main-material-inventory-price')"
			></bee-confirm-dialog>
		</div>
	</div>
</template>
<script>
import store from "../../../store/index.js";
import { mapState, mapGetters } from "vuex";
import actions from "../../../permissions/actions-names.js";
import ls from "../../../settings/localStorageExtension";
import rules from "../../../validation";
import { userType, type, inventoryPriceType, quantityStatus, quantityStatusValues } from '@/helpers/enums';
import { multipleWarehouses, separationOfInvoices, /* useChildrenMaterialStatement */ } from '@/configs/global'

export default {
	data: () => ({
		alertEditingPrimaryMaterial: false,
		inventoryPrice: null,
		...rules,
		valid: false,
		dialogEditInventoryPrice: false,
		actions,
		where_materials_have_balances: true,
		zebra: true,
		loading: true,
		with_primary_materials: null,
		materials_id: [],
		warehouse_id: null,
		selectedRow: {
			material_id: null,
			price: { amount: null, currency_id: null }
		},
		default_summary: {
			inventory_is_not_complete: null,
			sum_quantity: null,
			sum_total_amount: { amount: null, currency_id: null },
			total_count: null
		},
		showExportBtns: false,
		userType,
		quantityStatus,
		type,
		inventoryPriceType,
		multipleWarehouses,
		// materialDeliveryStatus,
		DeliveryStatus: null,
		quantityStatusValues,
		quantity_status: null,
		searchingLoading: false,
		materialsLoading: false,
		warehousesLoading: false
	}),

	computed: {
		...mapState({
			warehouses: state => state.warehouses.warehouses,
			materials: state => state.materials.materials,
			inventory: state => state.statements.inventory,
			configs: state => state.configs.configs,
			unit_sizes: state => state.unitSizes.unit_sizes,
			// warehousesForKeeper: state => state.warehouses.warehousesForKeeper,
			warehousesForKeeper: state => state.permissions.warehousesForKeeper,
			userTypePermission: state => state.permissions.user_type,
		}),

		...mapGetters({
			getUnitById: 'unitSizes/getById',
			getMaterialById: 'materials/getMaterialById',
			getSettingByKey: 'settings/getSettingByKey'
		}),

		exportItems() {
			return [
				{
					text: this.$t('WarehouseInventoryPage.export-as-excel'),
					icon: 'mdi-microsoft-excel',
					context: 'inventory',
					action_name: actions.EXPORT_AS_PDF
				},
				{
					text: this.$t('WarehouseInventoryPage.print-warehouse-inventory'),
					icon: 'mdi-printer',
					context: 'inventory',
					action_name: actions.EXPORT_AS_PDF
				},
			]
		},

		isWarehousePermission() {
			return (this.userTypePermission === userType.warehouseKeeper && separationOfInvoices) || (this.userTypePermission === userType.warehouseManger && separationOfInvoices)
		},

		headers() {
			const headers = [
				{
                    text: this.$t('inputs.warehouse'),
                    name: 'warehouse',
                    value: 'material_id',
                    setValueExpr: value => 
						this.warehouses.find(c => c.id === this.materials.find(e => e.id === this.inventory?.inventory_rows.find(k => k.material_id === value).material_id).warehouse_id).name,
					sortable: false,
					width: '12%',
                },
				{
					text: this.$t('WarehouseInventoryPage.headers.material-no'),
					value: 'material_id',
					name: 'materialNumber',
					setValueExpr: (value) => this.getMaterialById(value).no,
					width: '8%',
					sortable: false
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.material-name'),
					value: 'material_id',
					name: 'materialName',
					setValueExpr: (value) => this.getMaterialById(value).name,
					width: '24%',
					sortable: false
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.count'),
					value: 'count',
					name: '',
					width: '5%',
					sortable: false
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.unit-size'),
					value: 'unit_size_id',
					name: 'unitSize',
					setValueExpr: (value) => this.getUnitById(value).name,
					width: '10%',
					sortable: false
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.sum-input-quantity'),
					value: 'sum_input_quantity',
					name: 'inputQuantity',
					width: '9%',
					setValueExpr: value => value?.quantity ?? '-',
					sortable: false
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.sum-output-quantity'),
					value: 'sum_output_quantity',
					name: 'outputQuantity',
					noNotAvailableText: true,
					width: '9%',
					setValueExpr: value => value?.quantity ?? '-',
					sortable: false
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.quantity'),
					value: 'quantity',
					name: 'quantity',
					setValueExpr: value => value?.quantity ?? '-',
					width: '10%',
					sortable: false
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.price'),
					value: 'new_price.amount',
					name: 'new_price',
					width: '7%',
					type: 'number-format',
					sortable: false
				},
				{
					text: this.$t('WarehouseInventoryPage.headers.total-amount'),
					value: 'calculated_total_amount.amount',
					name: 'totalAmount',
					type: 'number-format',
					width: '12%',
					sortable: false
				},
				{
                    text: '',
                    name: 'options',
                    value: 'options',
                    width: 34,
                    class: 'px-0',
                    cellClass: 'px-0',
					sortable: false
                }
			];

			if (this.isWarehousePermission) {
				headers.splice(headers.length - 2, 1);
			}

			return headers
		},

		menu_items() {
			return [
				{
					name: 'edit',
					disabled: this.file_is_locked,
					text: this.$t('WarehouseInventoryPage.context-menu.edit-inventory-price'),
					action_name: actions.EDIT
				},
				{
					name: 'statement',
					disabled: false,
					text: this.$t('WarehouseInventoryPage.context-menu.material-statement'),
					action_name: actions.GET
				}
			]
		},

		file_is_locked() {
			return this.configs?.financial_file?.is_locked;
		},
		inventory_rows() {
			return this.inventory?.inventory_rows || [];
		},	
		summary(){
			return this.inventory?.inventory_report_summary || this.default_summary
		},
		formTitle() {
			return this.$t('WarehouseInventoryPage.edit-inventory-price') + this.materials?.find(c => c.id == this.selectedRow.material_id)?.name;
		},
		sum_total_amount() {
			let amount = this.summary.sum_total_amount.amount
			let type = amount ? (amount >= 0 ? 'credit' : 'debit') : 'debit'
			return { amount, type }
		},
		total_count() {
			return { quantity: this.summary.total_count }
		},
		sum_quantity() {
			return { quantity: this.summary.sum_quantity }
		},

		contextMenuItems() {
			return [
				{
					title: this.$t('WarehouseInventoryPage.context-menu.edit-inventory-price'),
					event: 'edit',
					disabled: this.file_is_locked,
				},
				{
					title: this.$t('WarehouseInventoryPage.context-menu.material-statement'),
					event: 'statement',
					disabled: false
				}
			]
		},
        materialsRequest() {
            return this.materials_id?.map(t => {
                const material = this.getMaterialById(t);
                return {
                    material_id: t,
                    is_parent: material?.type === type.main,
                    warehouse_id: material.warehouse_id
                }
            }
            )
        },
		materialQuantityAlert () {
			return this.getSettingByKey('QtyColor')?.setting_value;
		}
	},

	methods: {
		search() {
			this.searchingLoading = true;
			store.dispatch("statements/createInventoryReport", {
				warehouse_id: this.materials_id[0]? null: this.warehouse_id,
				materialsRequest: this.materials_id[0]? this.materialsRequest : null,
				with_primary_materials: this.with_primary_materials,
				where_materials_have_balances: this.where_materials_have_balances,
				quantity_status: this.quantity_status
				// materialDeliveryStatus: this.deliveryStatus
				// with_children:
				// 	useChildrenMaterialStatement 
				// 		? Boolean(this.materials.filter(c => this.materials_id.includes(c.id) && c.type === type.main).length) 
				// 		: null
				
			})
			.finally(() => {
				this.showExportBtns = true;
				this.searchingLoading = false;
				this.zebra = !this.with_primary_materials;
			});
		},
		reset() {
			this.showExportBtns = false;
			this.warehouse_id = this.warehouses.find(c => c.is_default === true)?.id
			this.materials_id = [];
			this.with_primary_materials = false;
			this.where_materials_have_balances = true;
			this.zebra = true;
			this.deliveryStatus = null
			this.close();
			this.$store.dispatch("statements/clear");
			this.$refs["BeeAutocomplete"].$refs.BeeMaterialAutocomplete.$refs.BeeAutocomplete.focus();
		},
		// onChange(string) {
		// 	if (string == "material_id") {
		// 		this.warehouse_id = null;
		// 	} else {
		// 		this.material_id = null;
		// 	}
		// },
		editInventoryPrice(row) {
			if (row.is_parent) {
				this.alertEditingPrimaryMaterial = true;
				return;
			}
			this.selectedRow = { ...row };
			this.inventoryPrice =
				this.selectedRow.price && this.selectedRow.price.amount > 0
					? this.selectedRow.price.amount
					: null;
			this.dialogEditInventoryPrice = true;
		},
		confirmEditInventoryPrice() {
			store.dispatch("materials/updateinventoryPrice", {
				warehouse_id: this.materials.find(
					c => c.id == this.selectedRow.material_id
				).warehouse_id,
				material_id: this.selectedRow.material_id,
				invevtory_price: this.inventoryPrice
			})
			.then(() => this.search())
			.finally(() => this.close());
		},
		close() {
			this.selectedRow = {
				material_id: null,
				price: { amount: null, currency_id: null }
			};
			this.inventoryPrice = null;
			this.dialogEditInventoryPrice = false;
		},
		statement(row){
			let routeData = this.$router.resolve({name: 'material-statment', query: {id: row.material_id}});
			window.open(routeData.href, '_blank');
		},

		exportAs(exportType) {
			if (this.showExportBtns){
				this.$store.dispatch('reports/InventoryReport', {
					type: exportType,
					financialFileId: this.configs.financial_file.id,
					userId: ls.getLocalUser().id,
					warehouseId: this.materials_id[0]? null: this.warehouse_id,
					materialRequests: this.materials_id[0]?  JSON.stringify(this.materialsRequest) : null,
					withPrimaryMaterials: this.with_primary_materials,
					whereMaterialsHaveBalances: this.where_materials_have_balances,
					quantityStatus: this.quantity_status
					// withChildren: useChildrenMaterialStatement 
					// 	? Boolean(this.materials.filter(c => this.materials_id.includes(c.id) && c.type === type.main).length) 
					// 	: null
				})
			}
		}
	},

	mounted() {
		window.observer.observe(document.querySelector("#tool-bar"))
		window.observer.observe(document.querySelector("#footer"))
		let promises = [
			store.dispatch("warehouses/fetchAll").finally(() => {this.warehousesLoading = false;this.reset();}),
			store.dispatch("unitSizes/fetchAll")
		];
		if (!store.state.materials.materials.length) {
			this.materialsLoading = true;
			promises.push(store.dispatch("materials/fetchAll").finally(() => {
				this.materialsLoading = false;
			}))
		}
		Promise.all(promises).then(() => {
				if (this.$route.query.warehouseId) {
					this.warehouse_id = this.$route.query.warehouseId;
				}
				// this.search();

		}).finally(() => {
			this.loading = false;
		});

	},

	beforeDestroy() {
		this.$store.dispatch("statements/clear");
	},

	// async beforeRouteEnter(to, from, next) {
	// 	let promises = [
	// 		store.dispatch("warehouses/fetchAll"),
	// 		!store.state.materials.materials.length ? store.dispatch("materials/fetchAll") : null,
	// 		store.dispatch("unitSizes/fetchAll")
	// 	];

	// 	await Promise.all(promises);
	// 	next();
	// }
};
</script>
<style scoped>
.small {
	max-width: 600px;
	margin: 150px auto;
}
.small-font-size .v-label {
	font-size: 0.8rem !important;
	padding-right: 0px !important;
}
.my-border {
	border: 1px solid !important;
	border-color: #f1f1f1 !important;
}
</style>